import { CtaButtonType } from '@pairy/sheard/types';
import { useAtomValue } from 'jotai';

import { currentPageAtom } from '../../../../store/index.atom';
import CtaButton from '../CtaButton';

import * as Styled from './index.styles';

interface Props {
  ctaButtonList?: CtaButtonType[];
  isPreview?: boolean;
}

const CtaButtonLayer = ({ ctaButtonList, isPreview }: Props) => {
  const currentPage = useAtomValue(currentPageAtom);

  const currentCtaButton = ctaButtonList?.find(
    (item) => item.page === currentPage,
  );

  return (
    <Styled.FlexBottomWrapper>
      {currentCtaButton && (
        <CtaButton
          id={currentCtaButton.id}
          button={currentCtaButton.button}
          url={currentCtaButton.url}
          page={currentCtaButton.page}
          isPreview={isPreview}
        />
      )}
    </Styled.FlexBottomWrapper>
  );
};

export default CtaButtonLayer;
